// @flow
// eslint-disable-next-line flowtype/newline-after-flow-annotation
import useTourViewedDetails from './useTourViewedDetails'

export default useTourViewedDetails
